export function schema_docx() {
	return {
		title: "Paramètres",
		type: "object",
		properties: {
			template_url: {
				title: "Url du template docx",
				type: "string",
			},
			column_name: {
				title: "Colonne ou valeur des noms des fichiers de résultats",
				type: "string",
				default: "name",
			},
			column_url_result: {
				title: "Colonne des url des fichiers de résultats",
				type: "string",
				default: "",
			},
			column_url: {
				title: "Colonne des url des fichiers",
				type: "string",
				default: "",
			},
			options: {
				title: "Options",
				type: "object"
			},
			pdf: {
				title: "PDF",
				type: "boolean",
				format: "checkbox"
			},
		},
	};
}
